import React, { useContext } from "react";

import { useHistory } from "react-router-dom";
import { MenuItem } from "@material-ui/core";

import { routes } from "../../api/paths";
import { userLogout } from "../../api/logout";
import { UserContext } from "../../Routes";

type RodaMenuItemsProps = {
  setSelectedRequest?: React.Dispatch<React.SetStateAction<number>>;
  handleClose?: () => void;
  className?: string;
};

export default function MenuItems({
  setSelectedRequest,
  handleClose,
  className,
}: RodaMenuItemsProps) {
  const history = useHistory();

  const { user, setUser } = useContext(UserContext);

  const onLogout = async () => {
    await userLogout();
    setUser(null);
    history.push(routes.LOGIN_URL);
  };

  return (
    <>
      {(user?.authority === "RODA" || user?.authority === "SUPER_ADMIN") && (
        <>
          <MenuItem
            onClick={() => {
              if (handleClose) {
                handleClose();
              }
              history.push(routes.RODA_HOMEPAGE_URL);
            }}
            className={className}
          >
            Početna
          </MenuItem>
          <MenuItem
            onClick={() => {
              if (handleClose) {
                handleClose();
              }
              history.push(routes.RODA_USER_ADMINISTRATION_URL);
            }}
            className={className}
          >
            Administracija
          </MenuItem>
          <MenuItem
            onClick={() => {
              if (setSelectedRequest) {
                setSelectedRequest(0);
              }
              if (handleClose) {
                handleClose();
              }
              history.push(routes.RODA_REQUESTS_URL);
            }}
            className={className}
          >
            Zahtjevi
          </MenuItem>
        </>
      )}
      <div style={{ flexGrow: 1 }} />
      <MenuItem onClick={onLogout} className={className}>
        Odjava
      </MenuItem>
    </>
  );
}
